import { useQuery } from "@tanstack/react-query";
import { getResignation } from "../api/resignation.api";
import { Resignation } from "../resignation.types";

export const resignationQueryKeys = {
  all: ["emp-resignation"] as const,
  list: (employeeId: number) =>
    [resignationQueryKeys.list, "list", employeeId] as const,
};

export const useResignation = () => {
  return useQuery<Resignation[]>({
    queryKey: resignationQueryKeys.all,
    queryFn: () => getResignation(),
    staleTime: 1000 * 60 * 60,
    gcTime: 1000 * 60 * 60,
  });
};
